import {
  XA_FETCH_USERKEY_POST,
  XA_FETCH_USERKEY_SUCCESS,
  XA_FETCH_USERKEY_FAILURE,
} from '../../actions/xAgent';

const INITIAL_STATE = {
  userApiKey: undefined,
};

export default function xAgentUserKeyReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case XA_FETCH_USERKEY_SUCCESS: {
      // make it backward compatible
      if (action.payload.data) {
        return {
          ...state,
          userApiKey: action.payload.data.map(k => k.apiKey),
        };
      }
      return {
        ...state,
        userApiKey: action.payload.key,
      };
    }
    case XA_FETCH_USERKEY_FAILURE:
    case XA_FETCH_USERKEY_POST:
    default: {
      return state;
    }
  }
}
